export default __webpack_public_path__ + "static/media/patient-hcp.4eb45b2f.jpg";